import {
  LIST_CAMPUS_REQ,
  LIST_CAMPUS_SUCCESS,
  LIST_CAMPUS_FAILED,
  CREATE_CAMPUS_REQ,
  CREATE_CAMPUS_SUCCESS,
  CREATE_CAMPUS_FAILED,
  CREATE_CAMPUS_RESET,
  UPDATE_CAMPUS_REQ,
  UPDATE_CAMPUS_SUCCESS,
  UPDATE_CAMPUS_FAILED,
  UPDATE_CAMPUS_RESET,
  DELETE_CAMPUS_REQ,
  DELETE_CAMPUS_SUCCESS,
  DELETE_CAMPUS_FAILED,
  DELETE_CAMPUS_RESET,
  LIST_CAMPUS_SINGLE_DATA_REQ,
  LIST_CAMPUS_SINGLE_DATA_SUCCESS,
  LIST_CAMPUS_SINGLE_DATA_FAILED,
  LIST_CAMPUS_SINGLE_DATA_RESET,
  CAMPUS_LIST_BY_COURSE_ID_REQ,
  CAMPUS_LIST_BY_COURSE_ID_SUCCESS,
  CAMPUS_LIST_BY_COURSE_ID_FAILED,
  CAMPUS_LIST_BY_COURSE_ID_RESET,
} from "../Constants/campusConstant";

export const CAMPUS_LIST_REDUCER = (state = {}, { type, payload }) => {
  switch (type) {
    case LIST_CAMPUS_REQ: {
      return { Campus_List_Loading: true };
    }
    case LIST_CAMPUS_SUCCESS: {
      return { Campus_List_Loading: false, Campus_Lists: payload };
    }
    case LIST_CAMPUS_FAILED: {
      return { Campus_List_Loading: false, Campus_List_Error: payload };
    }
    default:
      return state;
  }
};

export const CAMPUS_SINGLE_DATA_REDUCER = (state = {}, { type, payload }) => {
  switch (type) {
    case LIST_CAMPUS_SINGLE_DATA_REQ: {
      return { Campus_Single_Data_loading: true };
    }

    case LIST_CAMPUS_SINGLE_DATA_SUCCESS: {
      return { Campus_Single_Data_loading: false, Campus_Single_Data: payload };
    }

    case LIST_CAMPUS_SINGLE_DATA_FAILED: {
      return {
        Campus_Single_Data_loading: false,
        Campus_Single_Data_Error: payload,
      };
    }

    case LIST_CAMPUS_SINGLE_DATA_RESET: {
      return {};
    }

    default:
      return state;
  }
};

export const CAMPUS_CREATE_REDUCER = (state = {}, { type, payload }) => {
  switch (type) {
    case CREATE_CAMPUS_REQ: {
      return { Create_Campus_Loading: true };
    }
    case CREATE_CAMPUS_SUCCESS: {
      return { Create_Campus_Loading: false, Create_Campus_Success: payload };
    }
    case CREATE_CAMPUS_FAILED: {
      return { Create_Campus_Loading: false, Create_Campus_Error: payload };
    }
    case CREATE_CAMPUS_RESET: {
      return {};
    }
    default:
      return state;
  }
};

export const CAMPUS_UPDATE_REDUCER = (state = {}, { type, payload }) => {
  switch (type) {
    case UPDATE_CAMPUS_REQ: {
      return { Update_Campus_Loading: true };
    }
    case UPDATE_CAMPUS_SUCCESS: {
      return { Update_Campus_Loading: false, Update_Campus_Success: payload };
    }
    case UPDATE_CAMPUS_FAILED: {
      return { Update_Campus_Loading: false, Update_Campus_Error: payload };
    }
    case UPDATE_CAMPUS_RESET: {
      return {};
    }
    default:
      return state;
  }
};

export const CAMPUS_DELETE_REDUCER = (state = {}, { type, payload }) => {
  switch (type) {
    case DELETE_CAMPUS_REQ: {
      return { Delete_Campus_Loading: true };
    }
    case DELETE_CAMPUS_SUCCESS: {
      return { Delete_Campus_Loading: false, Delete_Campus_Success: payload };
    }
    case DELETE_CAMPUS_FAILED: {
      return { Delete_Campus_Loading: false, Delete_Campus_Error: payload };
    }
    case DELETE_CAMPUS_RESET: {
      return {};
    }
    default:
      return state;
  }
};

export const CAMPUS_LIST_BY_COURSE_REDUCER = (
  state = {},
  { type, payload }
) => {
  switch (type) {
    case CAMPUS_LIST_BY_COURSE_ID_REQ: {
      return { Campus_list_By_Course_Loading: true };
    }

    case CAMPUS_LIST_BY_COURSE_ID_SUCCESS: {
      return {
        Campus_list_By_Course_Loading: false,
        Campus_list_By_Course: payload,
      };
    }

    case CAMPUS_LIST_BY_COURSE_ID_FAILED: {
      return {
        Campus_list_By_Course_Loading: false,
        Campus_list_By_Course_Error: payload,
      };
    }
    case CAMPUS_LIST_BY_COURSE_ID_RESET: {
      return {};
    }
    default:
      return state;
  }
};
